import { Spin } from 'antd';
import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isTokenExpired } from '../utils/jwtUtils';

interface ProtectedRouteProps {
  children?: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Check token expiration on mount and when navigating
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token && isTokenExpired(token)) {
      // Token expired, remove it
      localStorage.removeItem('authToken');
      sessionStorage.setItem('sessionExpired', 'true');
    }
  }, []);

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If children are provided (legacy support), render them
  // Otherwise, use Outlet for nested routes
  return children || <Outlet />;
};

export default ProtectedRoute;
